import { cn } from '@restworld/utils-common';

export type ModalSubTitleProps = {
  children: React.ReactNode | string;
};

export const AuthSubtitle = ({
  isModal = true,
  className,
  ...props
}: { isModal?: boolean } & React.HTMLAttributes<HTMLParagraphElement>) => (
  <p className={cn('text-base font-normal text-gray-600 text-center', !isModal && 'text-left', className)} {...props} />
);
